<style scoped>
    @import url("../../styles/smartControl/imagensSC.scss");
</style>

<template>
    <div class="box_imgSC">

        <!-- MAIN TIT -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-image-multiple-outline</v-icon>
            <span class="ml-2">Imagens</span>
        </div>

        <div class="painel2" v-if="flagMsgSistema">
            <span>{{ msgSistema }}</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- Caixa de diálogo aberta após click "filtrar busca" -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="">
                <!-- componente calendar -->
                <DialogExec :liDatas2conv2Date="liDatas2conv2Date" 
                @fromDialog="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <div class="mt-2 mb-2" v-if="liImgExib.length === 0 && !flagLoading" :style="{'align-self':'center'}"
        >Nenhuma imagem capturada ainda.</div>
        
        <!-- LOADING após search btn -->
        <div v-if="flagLoading && !flagMsgSistema" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="tit2 mt-4 ml-2" v-if="!flagLoading">Selecione a câmera</div>

        <div class="macro_el" v-if="!flagLoading">
            <div class="painelSearch">
                <div class="searchBar mt-1 mb-1">

                    <v-autocomplete
                    v-model="endFolderSelected"
                    :items="liEndFolders"
                    color="rgb(247,215,46)"
                    class="w-100"
                    @update:modelValue="changeEndFolderSelected"
                    ></v-autocomplete>
                </div>
            </div>
        </div>

        <div class="painel2" v-if="!flagLoading">

            <!-- LARGE CARD -->
            <div class="card_status_cam">
                <div class="tit mb-4">
                    <span>Câmera</span>
                    <span>{{ endFolderSelected }}</span>
                </div>
                <div class="body">
                    <v-icon class="mb-2" size="36">mdi-camera-wireless-outline</v-icon>
                    <div class="mb-1" :style="{'font-size':'0.8rem'}">Última captura:</div>
                    <div :style="{'font-size':'1.2rem'}">{{ lastImgDate }}</div>
                </div>
            </div>        
        </div>

        <div class="tit2 mt-4 ml-2" v-if="!flagLoading">Histórico de imagens capturadas</div>

        <div class="painel3" v-if="!flagLoading">

            <div class="mb-2">
                <v-chip color="#F5DDC0">{{ msgChipHistImgs }}</v-chip>
                <v-chip class="ml-2" color="#F39C12" @click="initRaw()">
                    <div>Reset</div>
                    <v-icon class="ml-1" size="16">mdi-cursor-default-click</v-icon>
                </v-chip>
            </div>

            <div class="subPainel3" v-if="flagExibImgs">

                <div @click="changeDate()"
                class="card_img_mais mb-2" 
                @mouseover="bgFilter='#F39C12'" 
                @mouseleave="bgFilter='rgba(255,255,255,0.9)'"
                :style="{'background':bgFilter}"
                >
                    <div class="btn_filtro" :style="{'font-size':'0.8rem'}">
                        <v-icon class="mb-1" size="24">mdi-calendar-cursor</v-icon>
                        Filtrar busca
                    </div>
                </div>

                <div class="card_img mb-2" v-for="(el,i) in liImgExib" :key=i>
                    
                    <v-img cover :src="el.img" />

                    <div class="txt_img mt-1">
                        <v-icon class="mr-1" size="16">mdi-camera-outline</v-icon>
                        <div>{{ el.txt }}</div>

                        <!-- DOWNLOAD IMG -->
                        <v-icon 
                        color="#F5DDC0" 
                        class="ml-1" 
                        size="32"
                        :style="{'cursor':'pointer'}"
                        @click="getImgCDN(el.img)"
                        >
                            mdi-download-circle-outline
                        </v-icon>

                    </div>
                </div>
            </div>
        </div>

        <div class="tit2 mt-4 ml-2" v-if="!flagLoading">Evolução dos descritores da imagem</div>

        <div class="painel2" v-if="!flagLoading">
            Desabilitado
        </div>

        <div class="tit2 mt-4 ml-2" v-if="!flagLoading">Análise do alvo da captura</div>

        <div class="painel2" v-if="!flagLoading">
            Desabilitado
        </div>

    </div>
</template>

<script>
import axios from 'axios'

import DialogExec  from './subImg/DialogExec.vue'

export default {

    components:{DialogExec},

    data() {
        return {
            
            flagMsgSistema:false, // sistema geral precisa estar definido para req init.
            msgSistema:'Selecione um sistema na página "Início"',

            flagLoading:true, // init true loading em produção
            
            flagDialog:false,
            msgChipHistImgs:'Iniciando busca...',
            bgFilter:'rgba(255,255,255,0.9)', // cor hover btn filtro imagem por data

            // <-- rcv via api sc
            lastImgDate:'---',
            r_img:'',
            liImg:[],
            flagExibImgs:false,
            liImgExib:[],
            liDatas2conv2Date:[], // -- lista de datas (dias) disponíveis para exib calendar.

            //
            liDescr:[],

            // search bar
            liEndFolders:["upinc_blueberry","upinc_tangerina","upinc_cherry"], // front hardcode
            endFolderSelected:"upinc_blueberry", // default
        }
    },

    methods:{

        changeEndFolderSelected(endFolderSelectedFromFront) {
            this.endFolderSelected = endFolderSelectedFromFront // up local exib
            this.handle_init()
        },

        changeDate() { this.flagDialog = true }, // -- abrir dialog calender

        desableDialog(e) {
            //console.log('event from child dialog calendar: ',e)
            this.flagExibImgs = false // desabilitar exibição de imagens.

            let dt_str = e
            dt_str = dt_str.replace(/\//g, "_") // -- conv '/' para '_'
            
            // -- montar nova lista de imagens a serem exibidas depois da filtragem por data no calendar.
            //let liTmpImgInv = this.liImg.slice().reverse()
            let liTmpImgInv = this.liImg
            let j = 0
            let el_exib = null
            let aux = null
            let dt_cut = null
            this.liImgExib = [] // reset exibição atual.
            while (j < this.liImg.length) { // <-- aqui serão exibidas todas as imagens do dia selecionado.

                dt_cut = liTmpImgInv[j]
                .match(/\d{2}_\d{2}_\d{4}/)[0]
                //.replace(/_/g, "/")

                // -- match dt.
                //if (dt_str == liTmpImgInv[j]['dt_']) {
                if (dt_str == dt_cut) {

                    aux = this.r_img + liTmpImgInv[j]
                    el_exib = {'img':aux,'txt':dt_str}
                    this.liImgExib.push(el_exib)
                }
                j++
            }

            this.msgChipHistImgs = 'Resultado filtrado'
            this.flagDialog = false // -- desabilitar dialog calendar
            this.flagExibImgs = true // habilitar exibição de imagens.
        },

        // DOWNLOAD ?
        getImgCDN(imgNameAndRoute) { 

            let partes = imgNameAndRoute.split("/")
            let imgName = partes[partes.length - 1]

            axios.get(imgNameAndRoute, {
                responseType: "blob"
            })
            .then(res => {
                const url = URL.createObjectURL(res.data)

                const a = document.createElement("a")
                a.href = url
                a.download = imgName
                document.body.appendChild(a)
                a.click()

                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            })
            .catch(err => { console.error(err) })
        },

        async preInit() {

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            // INIT GERAL
            let params = {'cliente':cl, 'sistema':this.sistema, 'end_folder':this.endFolderSelected}
            let rota_descr = '/getxagroximgxcdn'
            let url = self.$store.state.pathAxiosBASE + rota_descr
            try {
                const res = await axios.post(url, params, { headers })
                let pydic = res.data.result
                this.r_img = pydic['r'] + pydic['end']
                //console.log('this.r_img: ',this.r_img )
                return true
            } catch (e) {
                console.error(e)
                return false
            }
        },

        initInfo() {

            this.liDescr = [] // reset exemplo de exibição

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            // DESCR
            let params = {'cliente':cl, 'sistema':this.sistema} // end folder?
            let rota_descr = '/getxagroximgxdescr'
            let url = self.$store.state.pathAxiosBASE + rota_descr
            axios.post(url, params, {headers}).then(function (res) {
                self.liDescr = res.data.result
            })

            // RAW NAMES
            params = {'cliente':cl, 'sistema':this.sistema, 'marcador':'raw', 'end_folder':this.endFolderSelected}
            rota_descr = '/getxagroximgxnames'
            url = self.$store.state.pathAxiosBASE + rota_descr
            axios.post(url, params, {headers}).then(function (res) {

                self.liImg = []
                self.liImg = res.data.result
                
                if (self.liImg.length > 0) {
                    self.msgChipHistImgs = 'Mais recentes'
                    self.initRaw()
                }
                else {
                    self.msgChipHistImgs = 'Nenhuma imagem encontrada'
                }
            })
        },

        initRaw() {

            // - MOUNT RAW IMG

            this.liImgExib = [] // reset (pode ser chamado apartir do v-chip reset)

            // -- montar lista geral de imagens existentes.
            this.liDatas2conv2Date = []
            let c=0
            let aux = null
            while (c < this.liImg.length) {
                aux = this.liImg[c]
                .match(/\d{2}_\d{2}_\d{4}/)[0]
                .replace(/_/g, "/")
                if (c == 0) { this.lastImgDate = aux } // <-- label cam (last update)
                this.liDatas2conv2Date.push(aux)
                c++
            }

            // -- montar lista incial de imagens a serem exibidas.
            let j=0
            let dt_cut = null
            let el_exib = null
            let liTmpImgInv = this.liImg
            while (j < 3 && j < liTmpImgInv.length) { // <-- 3 imagens por vez no init exib.
                dt_cut = liTmpImgInv[j]
                .match(/\d{2}_\d{2}_\d{4}/)[0]
                .replace(/_/g, "/")
                aux = this.r_img + liTmpImgInv[j]
                el_exib = {'img':aux,'txt':dt_cut}
                this.liImgExib.push(el_exib)
                j++
            }
            this.msgChipHistImgs = 'Mais recentes' // usado quando btn reset
            this.flagExibImgs = true // habilitar exibição de imagens.

            this.flagLoading = false // finalmente permitir exibição geral
        },

        async handle_init() {
            this.flagLoading = true
            const ok = await this.preInit()
            //console.log('ok from await: ',ok)
            if (!ok) { 
                this.flagMsgSistema = true
                this.msgSistema = "Erro ao inicializar imagens"
                this.flagLoading = false
                return
            }
            else {
                this.initInfo()
            }
            this.flagLoading = false
        },
    },

    async created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        
        else { 

            //await this.preInit() // travar o fluxo aqui até terminar requisição.
            //this.initInfo()
            /*
            const ok = await this.preInit()
            console.log('ok from await: ',ok)
            if (!ok) { 
                this.flagMsgSistema = true
                this.msgSistema = "Erro ao inicializar imagens"
                this.flagLoading = false
                return
            }
            else {
                this.initInfo()
            }*/
            this.handle_init() // 13/05/2026
        }

        /*const ok = await this.preInit()

        if (!ok) {
            this.flagMsgSistema = true
            this.msgSistema = "Erro ao inicializar imagens"
            this.flagLoading = false
            return
        }

        this.initInfo()*/
    }
}
</script>